// extracted by mini-css-extract-plugin
module.exports = {"container":"_2TZ6v1ypCbgpi-zH3Iv-Lx"};